import {useGetAccountProfilesRolesQuery} from '../store/api/accountApi';
import {useMemo} from 'react';

const useOneOwnerRole = (accountID?: number) => {
    const {data: profiles = []} = useGetAccountProfilesRolesQuery({accountID});

    const oneOwnerRole = useMemo(() => {
        let ownerCount = 0;
        profiles.forEach(profile => {
            if (profile.roles?.includes('user.owner')) {
                ownerCount++;
            }
        });
        return ownerCount === 1;
    }, [profiles]);

    return {oneOwnerRole};
};

export {useOneOwnerRole};
